var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _path4, _rect5, _mask, _path5, _path6, _path7, _mask2, _path8, _path9, _path0, _rect6, _mask3, _path1, _path10, _path11, _rect7, _mask4, _path12, _path13, _path14, _rect8, _mask5, _path15, _path16, _path17, _rect9, _mask6, _path18, _path19, _path20, _rect0, _mask7, _path21, _path22, _path23, _rect1, _path24, _g, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTourStep2Fr = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  className: "tour-step2-fr_svg__svg-safari-fix",
  viewBox: "0 0 312 349",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ECECF2",
  d: "M33.094 31.665c0-16.568 13.431-30 30-30h186c16.568 0 30 13.432 30 30v310h-246z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M45.094 32.665c0-11.046 8.954-20 20-20h182c11.045 0 20 8.954 20 20v309h-222z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0A093D",
  d: "M66.496 77.299a2.93 2.93 0 0 0-1.216-1.265q-.778-.438-1.8-.438-1.118 0-1.994.503a3.6 3.6 0 0 0-1.378 1.427q-.486.925-.486 2.14t.486 2.156a3.6 3.6 0 0 0 1.378 1.427q.876.502 1.995.502 1.507 0 2.448-.843.94-.843 1.151-2.286h-4.232v-1.475h6.21v1.443a5.5 5.5 0 0 1-.94 2.416 5.5 5.5 0 0 1-1.962 1.767q-1.2.648-2.675.648-1.59 0-2.903-.73a5.6 5.6 0 0 1-2.091-2.058q-.762-1.314-.762-2.967t.762-2.967a5.5 5.5 0 0 1 2.091-2.043 5.83 5.83 0 0 1 2.903-.746q1.8 0 3.194.892 1.41.875 2.043 2.497zm3.769 3.518q0-1.346.551-2.383a4.12 4.12 0 0 1 3.664-2.19q1.055 0 1.832.422.795.405 1.265 1.022V76.39h1.865v8.933h-1.865v-1.33q-.47.633-1.28 1.055-.811.42-1.849.421a3.97 3.97 0 0 1-2.108-.584 4.33 4.33 0 0 1-1.524-1.653q-.55-1.07-.551-2.416m7.312.032q0-.923-.389-1.605a2.6 2.6 0 0 0-.989-1.037 2.6 2.6 0 0 0-1.33-.357q-.713 0-1.329.357-.616.34-1.005 1.021-.373.665-.373 1.589t.373 1.621q.39.698 1.005 1.07.633.357 1.33.357.712 0 1.329-.357.615-.356.989-1.037.39-.698.39-1.622m6.14-7.523v11.998H81.87V73.326zm1.811 7.49q0-1.344.552-2.383a4.12 4.12 0 0 1 3.664-2.188q1.053 0 1.832.421.794.405 1.265 1.022V76.39h1.864v8.933h-1.864v-1.33q-.47.633-1.281 1.055-.81.42-1.849.421a3.97 3.97 0 0 1-2.107-.584 4.33 4.33 0 0 1-1.524-1.653q-.552-1.07-.552-2.416m7.313.033q0-.923-.39-1.605a2.6 2.6 0 0 0-.989-1.037 2.6 2.6 0 0 0-1.33-.357q-.713 0-1.329.357-.615.34-1.005 1.021-.373.665-.373 1.589t.373 1.621q.39.698 1.005 1.07.633.357 1.33.357.714 0 1.33-.357.615-.356.988-1.037.39-.698.39-1.622"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 11,
  x: 230.739,
  y: 74.324,
  fill: "#ECECF2",
  rx: 5.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 198.035,
  height: 20.267,
  x: 57.414,
  y: 99.878,
  fill: "#fff",
  rx: 4.343
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 198.035,
  height: 20.267,
  x: 57.414,
  y: 99.878,
  stroke: "#E5E5EE",
  strokeWidth: 0.579,
  rx: 4.343
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 47.802,
  height: 7.406,
  x: 65.204,
  y: 106.309,
  fill: "#ECECF2",
  rx: 3.703
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#0F0E5B",
  fillRule: "evenodd",
  d: "m247.19 110.361 2.143 2.143c.415.415.415 1.09 0 1.505l-.169.169a1.05 1.05 0 0 1-.753.309c-.275 0-.545-.101-.753-.309l-2.195-2.195a3.3 3.3 0 0 1-1.25.246 3.323 3.323 0 0 1-3.32-3.32 3.32 3.32 0 0 1 3.315-3.32 3.323 3.323 0 0 1 3.32 3.32c0 .521-.125 1.013-.338 1.452m-2.977-3.807a2.36 2.36 0 0 0-2.355 2.355 2.36 2.36 0 0 0 2.355 2.355 2.36 2.36 0 0 0 2.355-2.355 2.36 2.36 0 0 0-2.355-2.355m4.266 6.939.168-.169h.005a.1.1 0 0 0 0-.14l-2.017-2.017a4 4 0 0 1-.318.304l2.022 2.022a.1.1 0 0 0 .14 0m-4.556-6.596a2.31 2.31 0 0 1 2.307 2.306.364.364 0 0 1-.362.362.364.364 0 0 1-.362-.362c0-.873-.709-1.583-1.583-1.583a.364.364 0 0 1-.361-.362c0-.197.164-.361.361-.361",
  clipRule: "evenodd"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 198.903,
  height: 190.835,
  x: 56.98,
  y: 128.369,
  stroke: "#E5E5EE",
  strokeWidth: 0.29,
  rx: 5.531
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "tour-step2-fr_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M57.125 133.146a4.63 4.63 0 0 1 4.632-4.632h189.349a4.63 4.63 0 0 1 4.633 4.632v16.632H57.125z"
}))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#F8F8FA",
  d: "M57.125 133.146a4.63 4.63 0 0 1 4.632-4.632h189.349a4.63 4.63 0 0 1 4.633 4.632v16.632H57.125z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5EE",
  d: "M56.836 133.146a4.92 4.92 0 0 1 4.921-4.922h189.349a4.92 4.92 0 0 1 4.922 4.922h-.579a4.343 4.343 0 0 0-4.343-4.343H61.757a4.343 4.343 0 0 0-4.343 4.343zm198.903 16.632H57.125zm-198.903 0v-16.632a4.92 4.92 0 0 1 4.921-4.922v.579a4.343 4.343 0 0 0-4.343 4.343v16.632zm194.27-21.554a4.92 4.92 0 0 1 4.922 4.922v16.632h-.579v-16.632a4.343 4.343 0 0 0-4.343-4.343z",
  mask: "url(#tour-step2-fr_svg__a)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#0F0E5B",
  d: "M95.182 136.383v5.763H94.09l-2.45-3.997v3.997H90.55v-5.763h1.089l2.458 4.002v-4.002zm.93 3.666v-.084q0-.471.135-.866a2 2 0 0 1 .392-.693q.257-.293.63-.455.371-.167.846-.167.483 0 .855.167.376.162.634.455.257.292.392.693.134.395.134.866v.084q0 .467-.134.866-.135.396-.392.693a1.8 1.8 0 0 1-.63.455 2.1 2.1 0 0 1-.85.163q-.475 0-.852-.163a1.76 1.76 0 0 1-.633-.455 2.1 2.1 0 0 1-.392-.693 2.7 2.7 0 0 1-.135-.866m1.045-.084v.084q0 .28.056.526.056.245.17.431a.84.84 0 0 0 .297.293.9.9 0 0 0 .443.103.87.87 0 0 0 .436-.103.84.84 0 0 0 .297-.293 1.3 1.3 0 0 0 .174-.431 2.4 2.4 0 0 0 .055-.526v-.084q0-.276-.055-.518a1.4 1.4 0 0 0-.174-.432.83.83 0 0 0-.74-.407.82.82 0 0 0-.733.407 1.4 1.4 0 0 0-.17.432 2.3 2.3 0 0 0-.056.518m4.861-1.223v3.404h-1.045v-4.282h.986zm-.154 1.109h-.321q0-.448.107-.824.111-.375.324-.653.214-.28.527-.435a1.65 1.65 0 0 1 .732-.155q.29 0 .531.087.241.084.415.266.178.177.273.467.095.285.095.685v2.857h-1.045v-2.751q0-.3-.087-.471a.47.47 0 0 0-.241-.237.9.9 0 0 0-.38-.071.813.813 0 0 0-.713.364 1.3 1.3 0 0 0-.166.392 2 2 0 0 0-.051.479m2.604-.194-.431.079q.003-.404.111-.756.107-.357.312-.622a1.46 1.46 0 0 1 .519-.419q.312-.155.72-.155.316 0 .57.091.257.087.44.281.181.19.277.495.099.305.099.744v2.751h-1.053v-2.755q0-.312-.087-.478a.46.46 0 0 0-.242-.23.9.9 0 0 0-.372-.067.785.785 0 0 0-.649.304 1 1 0 0 0-.162.333 1.5 1.5 0 0 0-.052.404"
})), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
  id: "tour-step2-fr_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M57.125 149.778h198.614v28.214H57.125z"
}))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M57.125 149.778h198.614v28.214H57.125z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5EE",
  d: "M57.125 149.778v-.289h-.29v.289zm198.614 0h.289v-.289h-.289zm-198.614 0v.29h198.614v-.579H57.125zm198.614 0h-.29v28.214h.579v-28.214zM57.125 177.992h.29v-28.214h-.58v28.214z",
  mask: "url(#tour-step2-fr_svg__b)"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#57568C",
  fillRule: "evenodd",
  d: "M73.339 168.518a4.633 4.633 0 1 0 0-9.265 4.633 4.633 0 0 0 0 9.265m0 1.158a5.79 5.79 0 1 0-.001-11.582 5.79 5.79 0 0 0 0 11.582",
  clipRule: "evenodd"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 73.539,
  height: 8.107,
  x: 89.552,
  y: 159.832,
  fill: "#ECECF2",
  rx: 4.053
})), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
  id: "tour-step2-fr_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M57.125 177.992h198.614v28.214H57.125z"
}))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#E2F7F4",
  d: "M57.125 177.992h198.614v28.214H57.125z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5EE",
  d: "M57.125 177.992v-.289h-.29v.289zm198.614 0h.289v-.289h-.289zm-198.614 0v.29h198.614v-.579H57.125zm198.614 0h-.29v28.214h.579v-28.214zM57.125 206.206h.29v-28.214h-.58v28.214z",
  mask: "url(#tour-step2-fr_svg__c)"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#056757",
  d: "M73.338 186.309a5.79 5.79 0 1 1 0 11.58 5.79 5.79 0 0 1 0-11.58m2.056 3.569a.58.58 0 0 0-.802.165l-1.861 2.822-.72-.719a.578.578 0 1 0-.82.818l1.223 1.223a.58.58 0 0 0 .892-.091l2.253-3.416a.58.58 0 0 0-.165-.802"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 73.539,
  height: 8.107,
  x: 89.551,
  y: 188.046,
  fill: "#BAE5DE",
  rx: 4.053
})), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
  id: "tour-step2-fr_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M57.125 206.205h198.614v28.213H57.125z"
}))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M57.125 206.205h198.614v28.213H57.125z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5EE",
  d: "M57.125 206.205v-.289h-.29v.289zm198.614 0h.289v-.289h-.289zm-198.614 0v.29h198.614v-.579H57.125zm198.614 0h-.29v28.213h.579v-28.213zM57.125 234.418h.29v-28.213h-.58v28.213z",
  mask: "url(#tour-step2-fr_svg__d)"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#57568C",
  fillRule: "evenodd",
  d: "M73.339 224.944a4.632 4.632 0 1 0 0-9.265 4.632 4.632 0 0 0 0 9.265m0 1.158a5.79 5.79 0 1 0 0-11.58 5.79 5.79 0 0 0 0 11.58",
  clipRule: "evenodd"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 73.539,
  height: 8.107,
  x: 89.552,
  y: 216.259,
  fill: "#ECECF2",
  rx: 4.053
})), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
  id: "tour-step2-fr_svg__e",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M57.125 234.419h198.614v28.213H57.125z"
}))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#E2F7F4",
  d: "M57.125 234.419h198.614v28.213H57.125z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5EE",
  d: "M57.125 234.419v-.29h-.29v.29zm198.614 0h.289v-.29h-.289zm-198.614 0v.289h198.614v-.579H57.125zm198.614 0h-.29v28.213h.579v-28.213zM57.125 262.632h.29v-28.213h-.58v28.213z",
  mask: "url(#tour-step2-fr_svg__e)"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#056757",
  d: "M73.338 242.735a5.79 5.79 0 1 1 0 11.58 5.79 5.79 0 0 1 0-11.58m2.056 3.57a.58.58 0 0 0-.802.165l-1.861 2.822-.72-.72a.58.58 0 0 0-.82.819l1.223 1.222a.577.577 0 0 0 .893-.091l2.252-3.416a.58.58 0 0 0-.165-.801"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 73.539,
  height: 8.107,
  x: 89.551,
  y: 244.473,
  fill: "#BAE5DE",
  rx: 4.053
})), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
  id: "tour-step2-fr_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M57.125 262.632h198.614v28.213H57.125z"
}))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M57.125 262.632h198.614v28.213H57.125z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5EE",
  d: "M57.125 262.632v-.29h-.29v.29zm198.614 0h.289v-.29h-.289zm-198.614 0v.289h198.614v-.579H57.125zm198.614 0h-.29v28.213h.579v-28.213zM57.125 290.845h.29v-28.213h-.58v28.213z",
  mask: "url(#tour-step2-fr_svg__f)"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#57568C",
  fillRule: "evenodd",
  d: "M73.339 281.371a4.632 4.632 0 1 0 0-9.265 4.632 4.632 0 0 0 0 9.265m0 1.158a5.79 5.79 0 1 0 0-11.58 5.79 5.79 0 0 0 0 11.58",
  clipRule: "evenodd"
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  width: 73.539,
  height: 8.107,
  x: 89.552,
  y: 272.686,
  fill: "#ECECF2",
  rx: 4.053
})), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
  id: "tour-step2-fr_svg__g",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M57.125 290.846h198.614v28.213H57.125z"
}))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M57.125 290.846h198.614v28.213H57.125z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5EE",
  d: "M57.125 290.846v-.29h-.29v.29zm198.614 0h.289v-.29h-.289zm-198.614 0v.289h198.614v-.579H57.125zm198.614 0h-.29v28.213h.579v-28.213zM57.125 319.059h.29v-28.213h-.58v28.213z",
  mask: "url(#tour-step2-fr_svg__g)"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#57568C",
  fillRule: "evenodd",
  d: "M73.339 309.585a4.632 4.632 0 1 0 0-9.265 4.632 4.632 0 0 0 0 9.265m0 1.158a5.79 5.79 0 1 0 0-11.58 5.79 5.79 0 0 0 0 11.58",
  clipRule: "evenodd"
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  width: 73.539,
  height: 8.107,
  x: 89.552,
  y: 300.899,
  fill: "#ECECF2",
  rx: 4.053
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  stroke: "#E5E5EE",
  strokeWidth: 0.337,
  d: "M56.301 55.53h198.277v.337H56.301z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#tour-step2-fr_svg__clip1_17379_42675)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5555E7",
  d: "M88.27 35.879a.5.5 0 0 1 .302.086c.088.061.152.15.183.252l2.013 5.312 1.744-5.299a.47.47 0 0 1 .416-.344h1.685c.309 0 .463.174.36.481l-4.006 11.744a.47.47 0 0 1-.501.34h-1.604c-.308 0-.465-.174-.36-.478l1.118-3.238-3.29-8.361c-.11-.291.026-.495.339-.495zm-24.412.058a.4.4 0 0 1 .24.237q.03.083.02.17v.824a.88.88 0 0 1-.173.53l-3.656 5.015h3.578a.4.4 0 0 1 .322.11.39.39 0 0 1 .11.32v1.41a.384.384 0 0 1-.345.338H57.47a.39.39 0 0 1-.345-.337v-.912a.88.88 0 0 1 .172-.53l3.665-5.016H57.65a.4.4 0 0 1-.232-.11.39.39 0 0 1-.111-.317v-1.324a.38.38 0 0 1 .343-.427h6.124q.043.005.084.019m16.058-3.648a.4.4 0 0 1 .317.122.4.4 0 0 1 .105.32v1.348c0 .267-.159.387-.447.4-.919.027-1.447.325-1.447 1.351v.089h2.78v-.266c0-2.302 1.227-3.358 3.765-3.358a.4.4 0 0 1 .32.117.4.4 0 0 1 .11.232v1.258c0 .27-.159.387-.447.4-.92.027-1.444.325-1.445 1.351v.266h1.548a.4.4 0 0 1 .228.108.38.38 0 0 1 .11.225v1.517a.377.377 0 0 1-.337.333h-1.549v6.447a.38.38 0 0 1-.11.224.39.39 0 0 1-.314.108h-1.454a.39.39 0 0 1-.315-.108.38.38 0 0 1-.11-.224v-6.446H78.45v6.437a.375.375 0 0 1-.423.332h-1.453a.383.383 0 0 1-.425-.332v-6.446h-.937a.4.4 0 0 1-.228-.109.38.38 0 0 1-.11-.224v-1.519a.38.38 0 0 1 .254-.313.4.4 0 0 1 .084-.019h.937v-.089c0-2.3 1.228-3.532 3.766-3.532m-10.192 3.627c2.54 0 4.298 1.981 4.32 4.48 0 .184-.014.354-.027.524a.38.38 0 0 1-.139.286.4.4 0 0 1-.309.087h-6.09c.301 1.214 1.231 1.766 2.334 1.767a2.2 2.2 0 0 0 1.565-.622.7.7 0 0 1 .503-.22l1.38-.011c.297 0 .46.185.336.441-.651 1.433-2.062 2.233-3.82 2.233-2.804 0-4.618-1.957-4.618-4.483s1.857-4.482 4.565-4.482m-.012 1.97c-1.18 0-1.985.627-2.25 1.691h4.346a1.98 1.98 0 0 0-.717-1.245 2.03 2.03 0 0 0-1.379-.446"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#84E7D7",
  fillOpacity: 0.843,
  d: "M103.661 41.106c.4-.165.845-.197 1.265-.09s.793.348 1.062.685c.269.336.42.75.428 1.178a1.98 1.98 0 0 1-.591 1.425 2.048 2.048 0 0 1-1.442.587h-6.055a.68.68 0 0 1-.475-.194.66.66 0 0 1 0-.937.68.68 0 0 1 .475-.194h6.077a.68.68 0 0 0 .465-.17.66.66 0 0 0 .22-.44.66.66 0 0 0-.127-.4.67.67 0 0 0-.772-.235.68.68 0 0 0-.334.26.66.66 0 0 1-.574.332.68.68 0 0 1-.567-.33.65.65 0 0 1-.008-.65c.218-.371.553-.661.953-.827m-3.144-.083c.365 0 .662.292.662.653s-.297.654-.662.654h-2.192a.66.66 0 0 1-.662-.654c0-.36.297-.653.662-.653zm7.042-7.775c.798.089 1.536.46 2.077 1.047.541.586.848 1.346.863 2.14a3.313 3.313 0 0 1-2.078 3.086c-.41.166-.85.25-1.294.248h-8.802a.68.68 0 0 1-.473-.194.658.658 0 0 1 0-.937.68.68 0 0 1 .473-.194h8.816a2.04 2.04 0 0 0 1.431-.58 2 2 0 0 0 .601-1.407 1.95 1.95 0 0 0-.516-1.279 2.009 2.009 0 0 0-2.593-.302 1.96 1.96 0 0 0-.802 1.126.64.64 0 0 1-.624.49h-.032a.65.65 0 0 1-.508-.24.63.63 0 0 1-.124-.543 3.27 3.27 0 0 1 1.324-1.897 3.34 3.34 0 0 1 2.261-.564m-8.734-.66a2.514 2.514 0 0 1 3.111.551c.373.434.582.982.591 1.551a2.47 2.47 0 0 1-.739 1.786 2.53 2.53 0 0 1-1.807.732h-1.656a.67.67 0 0 1-.473-.195.66.66 0 0 1 0-.936.68.68 0 0 1 .473-.194h1.671c.303.002.595-.108.817-.311.223-.203.358-.482.379-.78a1.14 1.14 0 0 0-.25-.738 1.178 1.178 0 0 0-1.45-.31c-.24.123-.43.325-.536.571a.677.677 0 0 1-.617.42.68.68 0 0 1-.543-.291.66.66 0 0 1-.072-.605c.209-.53.598-.973 1.101-1.251"
}))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  width: 311,
  height: 7,
  x: 1.094,
  y: 341.665,
  fill: "#ECECF2",
  rx: 3.5
})));
export default SvgTourStep2Fr;